import { usePrimaryProduct } from '../../../../controllers/store/bootstrap';
import { useFiltersToDisplay } from '../../../../controllers/store/search';
import { siteFilterId } from '../../../../controllers/store/search/filters/filter-ids';
import { useMaxInlineFilters } from './row-width';

// Width only decides how many of the store's inline ids fit; it never re-runs the partition.
export const useRefreshFilterPlacement = (): {
	filtersInLine: string[];
	filtersInDropdown: string[];
} => {
	const [primaryProduct] = usePrimaryProduct();
	const [{ filtersInLine, filtersInDropdown }] = useFiltersToDisplay({
		basedOnPrimaryProduct: false,
		useDisjointFilterPlacement: true,
		primaryProduct,
	});
	const maxInlineFilters = useMaxInlineFilters();

	// Site is placed in the dropdown for every app selection, universally rather than via the
	// store's product/inline partition. It is never inline, so width-based displacement below
	// (which only moves overflow out of filtersInLine) never touches it. Guard against a duplicate
	// entry in case the store's own partition ever starts including 'site' too.
	const dropdownWithSite = filtersInDropdown.includes(siteFilterId)
		? filtersInDropdown
		: [...filtersInDropdown, siteFilterId];

	if (maxInlineFilters === undefined) {
		return { filtersInLine, filtersInDropdown: dropdownWithSite };
	}

	return {
		filtersInLine: filtersInLine.slice(0, maxInlineFilters),
		filtersInDropdown: [...filtersInLine.slice(maxInlineFilters), ...dropdownWithSite],
	};
};
